<template>
  <form-kit
    :delay="300"
    autocomplete="off"
    :id="fieldId"
    :outer-class="`w-full ${$attrs.class}`"
    :inner-class="sizeClass"
    :placeholder="placeholder"
    v-model="filters.search_text"
  >
    <template #prefixIcon>
      <app-icon
        name="search"
        class="text-gray-500"
      />
    </template>
    <template
      #suffixIcon
      v-if="hasShortcut"
    >
      <keyboard-shortcut>K</keyboard-shortcut>
    </template>
  </form-kit>
</template>

<script setup>
import { onMounted, ref, computed } from 'vue';
import { useKeyPress } from '@/composables/useKeyPress';
import KeyboardShortcut from '@/components/ui/KeyboardShortcut.vue';

const props = defineProps({
  fieldId: {
    type: String,
    default: 'identifiers-search',
  },
  size: {
    type: String,
    default: 'md',
    validator: (value) => ['sm', 'md', 'lg'].includes(value),
  },
  hasShortcut: {
    type: Boolean,
    default: true,
  },
  placeholder: {
    type: String,
    default: 'Search by identifier value or display name...',
  },
  store: {
    type: Object,
    required: true,
    default: () => ({
      filters: {},
    }),
  },
});

const searchFieldRef = ref(null);
const { filters } = props.store;

const sizeClass = computed(() => {
  return {
    sm: 'input-sm',
    md: 'input-md',
    lg: 'input-lg',
  }[props.size];
});

useKeyPress({
  key: 'k',
  metaKey: true,
  ctrlKey: true,
  handler: () => {
    if (!searchFieldRef.value) return;
    searchFieldRef.value.focus();
  },
});

useKeyPress({
  key: 'Escape',
  handler: () => {
    if (!searchFieldRef.value) return;
    searchFieldRef.value.blur();
  },
});

onMounted(() => {
  searchFieldRef.value = document.getElementById(props.fieldId);
});
</script>
